export interface AdminSpaceUtilizationCriteria {
  startDate?: string,
  endDate?: string,
  buyerAccountId?: string,
  locationId?: string,
  supplierAccountId?: string,
  bookingNumber?: string,
  overageInvoiceNumber?: string,
  durationType?: string,
}

/** Keys that make the report search all dates while filled (see `withDateRangeBypass`). */
export const ADMIN_SPACE_USAGE_DATE_BYPASS_KEYS: readonly (keyof AdminSpaceUtilizationCriteria)[] = ['bookingNumber', 'overageInvoiceNumber'];
